"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.Category = exports.ImgWrap = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
exports.Wrap = app_1.styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: black;
  text-align: center;
  margin-bottom: ${(theme) => theme.spacing.large};
`;
exports.ImgWrap = app_1.styled.div `
  height: 24rem;
  width: 100%;
  margin-bottom: ${(theme) => theme.spacing.medium};
`;
exports.Category = app_1.styled.span `
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  color: ${(theme) => theme.colors.secondary};
`;
exports.Title = app_1.styled.span `
  font-weight: 400;
  font-size: 1.25rem;
`;
